/**************************************************
 * Nombre:       Lista_Contratos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid} from "@mui/material";
import {useContext, useEffect, useState} from "react";
import Tarjeta_Contratos from "../../Tarjetas_Especiales/Tarjeta_Contratos";
import {where} from "firebase/firestore";
import {usuarioContext} from "../../../App";
import {obtenerColWheres} from "../../../Servicios/BD/obtenerColWheres";

const Lista_Contratos = () => {
    const cData = useContext(usuarioContext)
    const [contratos, setContratos] = useState([]);

    useEffect(() => {

        let w = [where('idUsuario', '==', cData.usuario.id)]
        obtenerColWheres({col: 'contratos', wheres: w}).then((dox) => {
            setContratos(dox.data)
        })

    }, [cData.usuario])
    return (
        <Grid
            container
            justifyContent={'flex-start'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            spacing={2}
        >

            {contratos.map((item, index) => (
                <Grid container size={{xs: 12, sm: 6, md: 6}} sx={{justifyContent: 'flex-start'}}>
                    <Tarjeta_Contratos item={item}/>
                </Grid>
            ))}

        </Grid>
    )

}
export default Lista_Contratos    